//MISC
import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_SIZE,
  MARGIN,
} from "constants/variables";

//LIBRARY

import styled from "styled-components";

//ASSETS
import cursorIcon from "assets/img/Cursor.png";

export const DatePickerContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.Cultured};
  border-radius: ${BORDER_RADIUS.radius24};
  padding: ${MARGIN.max24} ${MARGIN.max40} ${MARGIN.max32} ${MARGIN.max40};
  width: 100%;
  max-width: 1464px;
  min-width: 760px;
  gap: ${MARGIN.max20};
  @media (max-width: ${DEVICE_SIZE.TABLET_MAX}) {
    padding: ${MARGIN.max24};
  }
  @media (max-width: 768px) {
    width: 100%;
    min-width: 0px;
  }
`;

export const HorizontalLine = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${COLORS.lineColor};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${MARGIN.max40};
  width: 100%;
  @media (max-width: 1800px) {
    gap: ${MARGIN.max20};
  }
  @media (max-width: ${DEVICE_SIZE.MOBILE}) {
    gap: ${MARGIN.max24};
    // flex-direction: column;
    justify-content: space-around;
  }
`;

export const YearControl = styled.button``;

export const YearContainer = styled.div`
  display: flex;
  gap: ${MARGIN.max32};
  align-items: center;
  @media (max-width: 1800px) {
    gap: ${MARGIN.fix16};
  }
  @media (max-width: ${DEVICE_SIZE.MOBILE}) {
    gap: 0px;
  }
`;

export const YearWrapper = styled.div`
  width: 60px;
  height: 34px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  @media (max-width: 1800px) {
    width: auto;
  }
  @media (max-width: ${DEVICE_SIZE.MOBILE}) {
    min-width: 60px;
    justify-content: center;
  }
`;

export const MonthWrapper = styled.div`
  min-width: 117px;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1800px) {
    width: auto;
    min-width: 70px;
  }
`;

export const LeftArrow = styled.img`
  width: 15px;
  height: 24px;
`;

export const RightArrow = styled.img`
  width: 15px;
  height: 24px;
  rotate: calc(180deg);
`;

export const VerticalLine = styled.div`
  width: 2px;
  height: 57px;
  background-color: ${COLORS.lineColor};
`;

export const MonthsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  /* margin: 10px 0; */
  width: 100%;
  @media (max-width: 1240px) {
    overflow-x: auto;
    -ms-overflow-style: none; /* Hide scrollbar in Internet Explorer and Edge */
    scrollbar-width: none; /* Hide scrollbar in Firefox */

    &::-webkit-scrollbar {
      display: none; /* Hide scrollbar in WebKit browsers (Chrome, Safari) */
    }
  }
`;

export const Month = styled.div<{ selected: boolean }>`
  width: 64px;
  height: 49px;
  padding: ${MARGIN.max12} ${MARGIN.fix16};
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  background-color: ${({ selected }) =>
    selected ? COLORS.VividAuburn : "transparent"};
  border-radius: ${BORDER_RADIUS.radius8};
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1430px) {
    gap: ${MARGIN.max20};
    padding: ${MARGIN.max12} ${MARGIN.max8};
    width: 46px;
    height: 49px;
  }
`;

export const DaysContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  @media (max-width: 1580px) {
    overflow-x: auto;
    padding-bottom: ${MARGIN.max8};
  }
  @media (max-width: 1240px) {
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const Day = styled.div<{ selected: boolean; workingDay: boolean }>`
  width: 46px;
  height: 49px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  background-color: ${({ selected }) =>
    selected ? COLORS.VividAuburn : "transparent"};
  border-radius: ${BORDER_RADIUS.radius8};
  
  /* Apply bold to the CustomText component for working days */
  .custom-text {
    font-weight: ${({ workingDay }) => (workingDay ? 'bold' : 'normal')} !important;
  }
  
  @media (max-width: 1580px) {
    min-width: 46px;
  }
`;
